import styled from 'styled-components'

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 90;
  background: rgba(0,0,0,.6);
`

export default Backdrop